/******************************************************************************************
 *	RC Date Filter
 *******************************************************************************************
 *
 * Takes a date and outputs a formatted date with DEFAULT_TIMEZONE at the end.
 *
 */
(function() {
  

  // eslint-disable-next-line lodash/prefer-lodash-method
  angular.module('rcFilters.date', []).filter(
    'rcDate',
    /* @ngInject */
    function(_, $filter, Settings, Utility) {
      return function(input, format) {
        if (input) {
          //If input is not an instance of Date, try to convert it into a date
          if (!_.isDate(input)) {
            var inputAsDate = new Date(input);
            if (Utility.isValidDate(inputAsDate)) {
              input = inputAsDate;
            } else {
              //Return the input, this is an invalid date
              return input;
            }
          }

          return $filter('date')(input, format || Settings.DEFAULT_DATE_FORMAT);
        }
        return input;
      };
    }
  );
})();
